import {
	Button,
	IconText,
	Image,
	Input,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Style from "./testimonialsForm.module.scss";
import useTestimonialsForm from "./useTestimonialsForm";
import {
	capitalizeInitial,
	capitalizeOnSpace,
	limitStrLength,
} from "../../../../utils/functions/table";

const TestimonialsForm = ({
	refetch,
	closeModal,
	isStickyFooter,
}) => {
	const {
		formik,
		selectedItemsDetails,
		imageCoverPreview,
		handleCoverImage,
		profilefileInputRef
	} = useTestimonialsForm({ refetch, closeModal });


	return (
		<div className={`pro-w-100`}>

			<Input
				label={"Name*"}
				type="text"
				id="name
          "
				name="name
          "
				className={`pro-input lg ${formik.errors.name && formik.touched.name && "error"
					}`}
				{...formik.getFieldProps("name")}
				onChange={(event) => capitalizeOnSpace(event, formik.setFieldValue)}
				error={formik.errors.name && formik.touched.name}
				errorMessage={formik.errors.name}
			/>

<div className="input-wrap pro-mb-4">
				<label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
					Description*
				</label>
				<textarea
					id="description"
					rows={4}
					name="description"
					className={`pro-input lg ${formik.touched.description && formik.errors.description && " error"
						}`}
					{...formik.getFieldProps("description")}
				></textarea>
				{formik.touched.description && formik.errors.description && (
					<span className="error-text">{formik.errors.description}</span>
				)}
			</div>

			<Input
				label={"Rating*"}
				type="number"
				id="rate
          "
				name="rate
          "
				className={`pro-input lg ${formik.errors.rate && formik.touched.rate && "error"
					}`}
				{...formik.getFieldProps("rate")}
				onChange={(event) => capitalizeInitial(event, formik.setFieldValue)}
				error={formik.errors.rate && formik.touched.rate}
				errorMessage={formik.errors.rate}
			/>

			<div className="input-wrap pro-mb-4">
				<label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
					Image*
				</label>
				<div className="input-drag">
					<input
						type="file"
						placeholder="placeholder"
						accept=".jpeg, .jpg , .png"
						ref={profilefileInputRef}
						className={`pro-input ${formik.touched.image && formik.errors.image && " error"
							}`}
						id="image"
						name="image"
						onBlur={formik.handleBlur("image")}
						onChange={(e) => handleCoverImage(e)}
					/>
					<span className="input-drag-box">
						<IconText
							title={
								formik?.values?.image?.name !== undefined
									? limitStrLength(formik?.values?.image?.name, 30)
									: selectedItemsDetails !== "" &&
										selectedItemsDetails?.image
										? selectedItemsDetails?.image
										: `Drop files to attach or browse`
							}
						/>
					</span>
					{formik.touched.image && formik.errors.image && (
						<span className="error-text">{formik.errors.image}</span>
					)}
				</div>
			</div>
			<div className={`col-2 pro-my-2`}>
				<div className={`${Style.root_image_inner}`}>
					<Image
						width={100}
						height={100}
						src={imageCoverPreview}
						alt={`branch - 01`}
					/>
				</div>
			</div>

			{/* toggle button start  */}
			<div className="pro-toggle">
				<div className="pro-toggle-box">
					<input
						id="status"
						name="status"
						type="checkbox"
						checked={Boolean(formik.values?.status) ?? false}
						onChange={(e) => { formik.setFieldValue("status", !Boolean(formik.values?.status) ?? 0); }}
					/>
					<span></span>
				</div>
				<label>Status*</label>
			</div>
			{/* toggle button end  */}

			<div
				className={`col-12 pro-d-flex pro-justify-end ${isStickyFooter && "offcanvas-footer-sticky-btns"
					}`}
			>
				<Button
					className={"pro-btn-link lg pro-px-5"}
					onClick={() => closeModal()}
				>
					Cancel
				</Button>

				<Button
					className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
					type="submit"
					// disabled={hasUpdatePermission === true ? false : true}
					onClick={formik.handleSubmit}
				>
					{selectedItemsDetails === "" ? "Create" : "Update"}
				</Button>
			</div>
		</div>
	);
};

export default TestimonialsForm;
